import { QueryInItInfoResponse } from "@/types/queryInitInfo"
import { RouteRecordRaw } from "vue-router"

const modules = import.meta.glob([
  "../views/desktop/**/*.vue",
  "../components/desktop/**/*.vue",
  "../layouts/desktop/**/*.vue"
])
const renderAccountRoute = (): RouteRecordRaw[] => {
  return [
    {
      path: "/account",
      name: "Account",
      meta: { layout: "TwoPaneLayout", isNeedAuth: true, gap: 15, mode: "page" },
      components: {
        "left-group": modules[`../components/desktop/menu/Account.vue`],
        "right-group": modules[`../layouts/desktop/Account.vue`]
      },
      children: [
        {
          path: "/account/profile",
          name: "Profile",
          component: modules[`../views/desktop/profile/Profile.vue`]
        },
        {
          path: "/account/accountStatement",
          name: "AccountStatement",
          component: modules[`../views/desktop/accountStatement/AccountStatement.vue`]
        },
        {
          path: "/account/transferredLog",
          name: "TransferredLog",
          component: modules[`../views/desktop/transferredLog/TransferredLog.vue`]
        },
        {
          path: "/account/activityLog",
          name: "ActivityLog",
          component: modules[`../views/desktop/activityLog/ActivityLog.vue`]
        },
        {
          path: "/account/balanceOverview",
          name: "BalanceOverview",
          component: modules[`../views/desktop/balanceOverview/BalanceOverview.vue`]
        },
        {
          path: "/account/myBets",
          name: "MyBets",
          component: modules[`../views/desktop/myBets/MyBets.vue`],
          children: [
            {
              path: "/account/myBets/currentBets",
              name: "CurrentBets",
              component: modules[`../views/desktop/myBets/CurrentBets.vue`]
            },
            {
              path: "/account/myBets/betsHistory",
              name: "BetsHistory",
              component: modules[`../views/desktop/myBets/BetsHistory.vue`]
            },
            {
              path: "/account/myBets/profitLoss",
              name: "ProfitLoss",
              component: modules[`../views/desktop/myBets/ProfitLoss.vue`]
            }
          ]
        }
      ]
    }
  ]
}

export const renderRoutes = (data: QueryInItInfoResponse): RouteRecordRaw[] => {
  const { isRacingWebSite, isEnableGameHall } = data
  const accountRoutes = renderAccountRoute()
  return [
    {
      path: "/",
      component: modules[`../layouts/desktop/Default.vue`],
      redirect: { name: "Home" },
      children: [
        ...accountRoutes,
        {
          path: "/inPlay",
          name: "In-Play",
          meta: { gap: 15, layout: "TwoPaneLayout", mode: "default" },
          components: {
            "left-group": modules[`../views/desktop/inPlay/InPlay.vue`],
            "right-group": modules[`../layouts/desktop/RightGroup.vue`]
          }
        },
        {
          path: "/result",
          name: "In-Play-Result",
          meta: { gap: 15, layout: "TwoPaneLayout", mode: "default", isNeedAuth: true },
          components: {
            "left-group": modules[`../views/desktop/results/Results.vue`],
            "right-group": modules[`../layouts/desktop/RightGroup.vue`]
          }
        },
        {
          path: "/fullMarket/:eventType-:eventId",
          name: "FullMarket",
          meta: { gap: 5, layout: "ThreePaneLayout", mode: "default" },
          components: {
            "left-group": modules[`../components/desktop/menu/leagues/index.vue`],
            "middle-group": modules[`../views/desktop/fullMarket/FullMarket.vue`],
            "right-group": modules[`../layouts/desktop/RightGroup.vue`]
          }
        },
        ...(isEnableGameHall
          ? [
              {
                path: "/gameHall",
                name: "GameHall",
                meta: {
                  gap: "0px",
                  mode: "page",
                  layout: "SinglePaneLayout",
                  isNeedAuth: false
                },
                components: {
                  default: modules[`../views/desktop/gamehall/GameHall.vue`]
                }
              }
            ]
          : []),
        {
          path: "/highlight",
          name: "Highlight",
          meta: {
            gap: 15,
            mode: "default",
            layout: "ThreePaneLayout",
            isNeedAuth: false
          },
          components: {
            "left-group": modules[`../components/desktop/menu/leagues/index.vue`],
            "middle-group": modules[`../views/desktop/highlight/Highlight.vue`],
            "right-group": modules[`../layouts/desktop/RightGroup.vue`]
          }
        },
        {
          path: "/multiMarket",
          name: "MultiMarket",
          meta: {
            gap: 15,
            layout: "ThreePaneLayout",
            isNeedAuth: false,
            mode: "default"
          },
          components: {
            "left-group": modules[`../components/desktop/menu/leagues/index.vue`],
            "middle-group": modules[`../views/desktop/multiMarket/MultiMarket.vue`],
            "right-group": modules[`../layouts/desktop/RightGroup.vue`]
          }
        },
        {
          name: "Home",
          path: "/home",
          redirect: () => {
            if (isRacingWebSite) return { name: "Highlight", query: { eventType: 7 } }
            if (isEnableGameHall) return { name: "GameHall" }

            return { name: "Highlight" }
          }
        }
      ]
    },
    {
      path: "/approval",
      component: () => import("../layouts/desktop/Empty.vue"),
      children: [
        {
          path: "/terms",
          name: "Terms",
          component: modules[`../views/desktop/approval/Terms.vue`]
        },
        {
          path: "/resetPassword",
          name: "ResetPassword",
          component: modules[`../views/desktop/approval/ResetPassword.vue`]
        },
        {
          path: "/login",
          name: "Login",
          component: modules[`../views/desktop/approval/Login.vue`]
        }
      ]
    },
    {
      path: "/account/myBets",
      component: () => import("../layouts/desktop/Empty.vue"),
      children: [
        {
          name: "ProfitLossDetail",
          meta: {
            layout: "SinglePaneLayout",
            isNeedAuth: true,
            mode: "page"
          },
          path: "ProfitLossDetail",
          components: {
            default: modules[`../views/desktop/myBets/ProfitLossDetail.vue`]
          }
        }
      ]
    },
    {
      path: "/error-default",
      component: modules[`../layouts/desktop/Default.vue`],
      children: [
        {
          path: "404",
          name: "404",
          meta: {
            mode: "page",
            layout: "SinglePaneLayout",
            isNeedAuth: false
          },
          component: modules[`../views/desktop/pageError/404.vue`]
        }
      ]
    },
    {
      path: "/error-empty",
      component: modules[`../layouts/desktop/Empty.vue`],
      children: [
        {
          path: "/IPBlock",
          name: "IPBlock",
          component: modules[`../views/desktop/pageError/IPBlock.vue`]
        },
        {
          path: "/SystemMaintenance",
          name: "SystemMaintenance",
          component: modules[`../views/desktop/pageError/SystemMaintenance.vue`]
        },
        {
          path: "/AuthBlock",
          name: "AuthBlock",
          component: modules["../views/desktop/pageError/AuthBlock.vue"]
        }
      ]
    },
    {
      path: "/:pathMatch(.*)*",
      redirect: { name: "404" }
    }
  ]
}

export default {}
